import { type TAudioSuggestions as TApiAudioSuggestions, getAudioSuggestionsUrl } from '@core/api'
import { httpClient } from '@core/http-client'

import { convertAudioSuggestions } from '@core/converters'

type TGetAudioSuggestionsParams = {
    username: string
    slug: string
    signal?: AbortSignal
}

export const getAudioSuggestions = async ({
    username,
    slug,
    signal,
}: TGetAudioSuggestionsParams) => {
    const apiSuggestions = await httpClient
        .get(getAudioSuggestionsUrl(username, slug), { signal })
        .json<TApiAudioSuggestions>()

    return convertAudioSuggestions(apiSuggestions)
}
